import { Link } from 'react-router-dom';
import Segment from '../shared/segment';

function ExamsHeader() {
  return (
    <Segment bg color='blue' textAlign='center' className='flex flex-col gap-4'>
      <h1 className='text-xl font-medium'>آزمون‌های در دسترس</h1>
      <p>
        <span>برای دیدن </span>
        <span className='font-medium'>"نتایج آزمون‌های انجام شده"</span>
        <span> از منوی </span>
        <Link to='/results' className='font-medium text-blue-700'>
          نتایج
        </Link>
        <span> استفاده کنید.</span>
      </p>
    </Segment>
  );
}

export default ExamsHeader;
